import {
  PropsWithChildren, useEffect, useRef, useState,
} from 'react';
import classNames from 'classnames';
import {
  autoUpdate, flip, offset,
} from '@floating-ui/react-dom';
import styled from 'styled-components';
import styles from './LeftMenu.module.css';
import { useOutsideAlerter } from '../../../utils/eventAlerter';
import { Floating } from '../../../components/Floating';

export const SIDETOOLBAR_WIDTH = 274;

const SideMenu = styled.div<{ open?: boolean }>`
  background-color: var(--background-button);
  box-shadow: var(--shadow-modal);
  border-radius: 4px;
  opacity: ${(props) => (props.open ? 1 : 0)};
  transition: opacity 0.25s;
  visibility: ${(props) => (props.open ? 'open' : 'hidden')};
  width: 100%;
  padding: 5px 0px;
  pointer-events: auto;
`;

type LeftMenuItemProps = PropsWithChildren<{
  icon?: any;
  title: any;
  onClick?: (event: any) => void;
  command?: any;
  openMenuOnClick?: boolean;
  menuOpen?: boolean;
  onMenuClose?: () => void;
  testID?: string,
}>;
export function LeftMenuItem({
  icon,
  title,
  onClick,
  command,
  children,
  openMenuOnClick = false,
  menuOpen,
  onMenuClose,
  testID,
}: LeftMenuItemProps) {
  const [open, setopen] = useState(false);

  useEffect(() => {
    if (menuOpen !== undefined && menuOpen !== null) {
      setopen(menuOpen);
    }
  }, [menuOpen]);

  // When clicked outside of the component, close the resize
  const onClickOutside = () => {
    setopen(false);
    onMenuClose?.();
  };

  const ref = useRef<HTMLDivElement | null>(null);

  const onItemClick = (event: any) => {
    event.preventDefault();
    if (openMenuOnClick) {
      setopen((prevOpen) => !prevOpen);
    } else if (onClick) {
      onClick(event);
    }
  };

  useOutsideAlerter(ref, `left-menu-item-${title}`, onClickOutside);

  return (
    <div
      className={styles.itemWrapper}
      ref={ref}
    >
      <div
        className={classNames(`left-menu-item-${title}`, styles.itemContainer)}
        onClick={onItemClick}
        role="none"
        data-testid={testID}
      >
        <div className={styles.icon}>{icon}</div>
        <div className={styles.title}>{title}</div>
        <div className={styles.command}>{command}</div>
      </div>

      {
        open
        && (
          <Floating
            reference={ref}
            options={{
              placement: 'right-start',
              middleware: [
                offset(5),
                flip({ crossAxis: false }),
              ],
              whileElementsMounted: autoUpdate,
            }}
          >
            <SideMenu open={open}>
              {children}
            </SideMenu>
          </Floating>
        )
      }
    </div>

  );
}

LeftMenuItem.defaultProps = {
  icon: undefined,
  onClick: undefined,
  command: undefined,
  openMenuOnClick: undefined,
  menuOpen: undefined,
  onMenuClose: undefined,
  testID: undefined,
};
